export default "__VITE_ASSET__00cf62a8__"